/**
 * Meters of drift from the live fix past which a drop counts as hand-placed.
 *
 * Shared by the tree map and the irrigation map so the two surveys agree on
 * when a pan is "I moved this" rather than GPS noise.
 */
export const MANUAL_PLACEMENT_THRESHOLD_M = 1.5
